import { createMultiStyleConfigHelpers as i, defineStyle as r } from "@chakra-ui/styled-system";
import { subHeaderAnatomy as l } from "../anatomy/index.mjs";
import { headingTheme as e } from "./heading.mjs";
const { defineMultiStyleConfig: o, definePartsStyle: a } = i(l.keys), s = r({
  w: "full",
  color: "surface",
  display: "flex",
  flexDirection: "row",
  gap: "6",
  alignItems: "center",
  textStyle: "bodySm",
  bgGradient: "linear(to-r, primary.from, primary.to)",
  maxHeight: "56px",
  p: "4"
});
var t;
const n = r({
  ...e.baseStyle,
  ...(t = e.sizes) == null ? void 0 : t.sm,
  textAlign: "start",
  p: "0",
  hyphens: "manual",
  color: "white"
}), m = a({
  subheader: s,
  title: n
}), c = o({
  baseStyle: m
});
export {
  c as subHeaderTheme
};
